import Util from '../../util/index'

// HTTP 状态码错误说明
const errorMsg = {
  200: '服务器成功返回请求的数据。',
  201: '新建或修改数据成功。',
  202: '一个请求已经进入后台排队（异步任务）。',
  204: '删除数据成功。',
  400: '发出的请求有错误，服务器没有进行新建或修改数据的操作。',
  401: '用户没有权限（令牌、用户名、密码错误）。',
  403: '用户得到授权，但是访问是被禁止的。',
  404: '发出的请求针对的是不存在的记录，服务器没有进行操作。',
  406: '请求的格式不可得。',
  410: '请求的资源被永久删除，且不会再得到的。',
  422: '当创建一个对象时，发生一个验证错误。',
  500: '服务器发生错误，请检查服务器。',
  502: '网关错误。',
  503: '服务不可用，服务器暂时过载或维护。',
  504: '网关超时。'
}

// http 拦截器
export const requestInterceptor = {
  then: function(config) {
    return Promise.resolve(config)
  },

  catch: function(error) {
    return Promise.reject(error)
  }
}

export const responseInterceptor = {
  then: function(response) {
    // 文件下载 ，由 download.js 处理
    if (response.config.isDownload) {
      return response
    }

    if (response.data) {
      if (response.data.code >= 200 && response.data.code < 300) {
        return Promise.resolve(response.data)
      } else if (response.data.code === 401) {
        Peace.util.error(response.data.msg || '登录失效')
        Peace.cache.localStorage.clear()
        Peace.cache.sessionStorage.clear()
        setTimeout(() => {
          Util.location.redirectToLogin()
        }, 2000)
        return Promise.reject(response.data)
      } else {
        // !response.config.noErrTip && Peace.util.error(response.data.msg || '服务器异常')
        !response.config.noErrTip && Peace.util.error(response.data.errorMsg || response.data.msg || '服务器异常')
        return Promise.reject(response.data)
      }
    } else {
      Peace.util.error('服务器异常')
      return Promise.reject(response)
    }
  },

  catch: function(error) {
    if (error.response) {
      // 请求已发出，但服务器响应的状态码不在 2xx 范围内
      const {
        data: { msg, validMessageList },
        status
      } = error.response

      if (status === 401) {
        Peace.util.error(msg || '登录失效')
        Peace.cache.localStorage.clear()
        Peace.cache.sessionStorage.clear()
        setTimeout(() => {
          Util.location.redirectToLogin()
        }, 2000)
      } else if (validMessageList) {
        Peace.util.error('请求参数校验失败')
      } else {
        Peace.util.error(msg || errorMsg[status] || '服务器异常')
      }
      return Promise.reject(error.response)
    } else {
      Peace.util.error('服务器异常')
      return Promise.reject(error)
    }
  }
}

export default {
  requestInterceptor,
  responseInterceptor
}
